import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const ServicesBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Our" subTitle="Services" smText='Services'></Breadcrumb>
        </>
    );
};

export default ServicesBreadcrumb;